import React from 'react'

export function Header () {
    return (
      <header>
        <h1>GIT COMMANDER</h1>
      </header>
    )
}

export default  Header;
